import React, { useContext, useState } from "react";
import Sidebar from "./Comman/Sidebar";
import Header from "./Comman/Header";
import axios from "axios";
import { OnmaxContext } from "../OnmaxContext";
import { useNavigate } from "react-router-dom";

export default function ForgetPassword() {
  const { toastSuccess, toastError } = useContext(OnmaxContext);
  const [username, setusername] = useState("");
  const navigate = useNavigate();

  const [showOtp, setShowOtp] = useState(false);
  const [loadingOtp, setLoadingOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [email, setemail] = useState("");
  const [password, setpassword] = useState(""); // Used for Contact/New Password in the logic

  const updateContact = async (e) => {
    e.preventDefault();

    if (!password) {
      alert("Enter valid contact number");
      return;
    }
    if (!/^[0-9]{6,}$/.test(password)) {
      alert("Enter a valid password/contact");
      return;
    }

    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "ucontct",
        username: username,
        password: password,
        key: process.env.REACT_APP_KEY,
      });

      if (res.data.resCode === 200) {
        alert("Updated successfully!");
        navigate("/dashboard");
      } else {
        alert(res.data.message || "Error updating");
      }
    } catch (error) {
      alert(error.response?.data?.message || "Server Error");
    }
  };

  const sendOtp = async () => {
    if (!email) {
      toastError("Please enter your email");
      return;
    }

    try {
      setLoadingOtp(true);
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "send",
        key: process.env.REACT_APP_KEY,
        email: email,
        username,
        password: password,
      });

      if (res.data?.resCode === 200) {
        toastSuccess("OTP sent to your email");
        setShowOtp(true);
      } else {
        toastError(res.data.error || "Failed to send OTP");
      }
    } catch {
      toastError("Failed to send OTP");
    } finally {
      setLoadingOtp(false);
    }
  };

  const verifyOTP = async () => {
    if (otp.length !== 6) {
      toastError("Enter valid 6-digit OTP");
      return;
    }

    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "verifyemail",
        key: process.env.REACT_APP_KEY,
        email: email,
        otp: otp,
      });
      if (res.data?.resCode === 200) {
        toastSuccess(res.data?.message || "OTP verified");
        setShowOtp(false);
      } else {
        toastError(res.data?.message || "Invalid OTP");
      }
    } catch {
      toastError("OTP verification failed");
    }
  };

  const customStyles = `
    .ai-auth-container {
        min-height: calc(100vh - 88px);
        background: #f1f5f9;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px 20px;
    }
    
    .ai-auth-card {
        background: #ffffff;
        border-radius: 20px;
        padding: 40px;
        width: 100%;
        max-width: 480px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.05);
        border: 1px solid rgba(0, 0, 0, 0.05);
    }

    .ai-title { color: #1a2234; text-align: center; font-size: 26px; font-weight: 800; margin-bottom: 8px; }
    .ai-subtitle { color: #64748b; text-align: center; font-size: 14px; margin-bottom: 32px; }

    .db-input-wrapper {
      background: rgba(238, 242, 246, 0.5); 
      border-radius: 16px; 
      padding: 16px 20px; 
      border: 1px solid rgba(255, 255, 255, 0.8);
      box-shadow: 1px 20px 20px 0px #bfc9d8, 0 10px 20px rgba(0, 0, 0, 0.05), inset 0 1px 0 #ffffff;
      display: flex; align-items: center; gap: 12px;
      margin-bottom: 24px;
    }

    .db-input {
      background: transparent !important; border: none !important; outline: none !important; width: 100%; font-weight: 700; color: #000000 !important; font-size: 15px;
    }

    .db-modern-btn {
      background: linear-gradient(135deg, #006fe3, #005bb5);
      color: #fff; border: none; padding: 16px; border-radius: 14px;
      font-weight: 700; width: 100%; font-size: 16px;
      box-shadow: 0 4px 15px rgba(0, 111, 227, 0.3); transition: 0.3s;
      margin-top: 10px;
    }
    .db-modern-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 25px rgba(0, 111, 227, 0.4); }
  `;

  return (
    <>
      <style>{customStyles}</style>
      <div className="body-bg">
        <Sidebar />
        <Header />
        <section className="nftmax-adashboard nftmax-show">
          <div className="ai-auth-container">
            <div className="ai-auth-card">
              <h2 className="ai-title">Forget Password</h2>
              <p className="ai-subtitle">Recover your account access</p>

              {!showOtp ? (
                <form onSubmit={updateContact}>
                  <div className="db-input-wrapper">
                    <i className="fa fa-user" style={{ color: '#64748b' }}></i>
                    <input
                      className="db-input"
                      type="text"
                      placeholder="Username"
                      value={username}
                      onChange={(e) => setusername(e.target.value)}
                      required
                    />
                  </div>

                  <div className="db-input-wrapper">
                    <i className="fa fa-envelope" style={{ color: '#64748b' }}></i>
                    <input
                      className="db-input"
                      type="email"
                      placeholder="Email Address"
                      value={email}
                      onChange={(e) => setemail(e.target.value)}
                      required
                    />
                  </div>

                  <div className="db-input-wrapper">
                    <i className="fa fa-phone" style={{ color: '#64748b' }}></i>
                    <input
                      className="db-input"
                      type="text"
                      placeholder="New Password / Contact"
                      value={password}
                      onChange={(e) => setpassword(e.target.value)}
                      required
                    />
                  </div>

                  <button type="button" className="db-modern-btn" onClick={sendOtp} disabled={loadingOtp}>
                    {loadingOtp ? "Sending OTP..." : "Get OTP"}
                  </button>

                  <button type="submit" className="db-modern-btn" style={{ background: '#10b981', marginTop: '15px' }}>
                    Update Account
                  </button>
                </form>
              ) : (
                <div>
                  <div className="db-input-wrapper">
                    <input
                      className="db-input text-center fs-4"
                      type="text"
                      placeholder="Enter 6-digit OTP"
                      maxLength={6}
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                    />
                  </div>
                  <button className="db-modern-btn" onClick={verifyOTP}>
                    Verify OTP
                  </button>
                  <button className="db-modern-btn bg-secondary mt-2" onClick={() => setShowOtp(false)}>
                    Back
                  </button>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
